export default __webpack_public_path__ + "static/media/bernay6.cd1ab7ac.jpg";